import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DailyLogOperationInstance } from '../../../models/projects/operation.models';
import { DbContext, DbTable } from '../../data/dbcontext.service';
import { AppConfig } from '../../../app/app.config';

@Injectable()
export class LocalOperationSaveService {
  config = AppConfig.settings;
  private readonly operationsDataTable: DbTable;
  private readonly stepCollectionsDataTable: DbTable;
  private readonly dailyLogTable: DbTable;
  private readonly psoTable: DbTable;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext,
  ) {
    this.operationsDataTable = this.dbContext.tables.find(t => t.name === 'OperationsData');
    this.stepCollectionsDataTable = this.dbContext.tables.find(t => t.name === 'StepCollectionsData');
    this.dailyLogTable = this.dbContext.tables.find(t => t.name === 'DailyLogData');
    this.psoTable = this.dbContext.tables.find(t => t.name === 'ProjectSpecificOperationInstance');
  }

  saveProjectSpecificOperationInstance(localId: number, projectSpecificOperation: DailyLogOperationInstance) {
    this.dbContext.addOrUpdate(this.psoTable, <number>localId, projectSpecificOperation);
  }

}



// WEBPACK FOOTER //
// ./src/services/local/operation/local-operation-save.service.ts